import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const FiberPopListHeader = ({ viewMode, setViewMode }) => {
  const navigate = useNavigate();

  const handleChange = (_, newValue) => {
    if (newValue !== null) {
      setViewMode(newValue);
    }
  };

  return (
    <>
      <div
        style={{
          width: '100%',
          padding: '0px 2%',
          display: 'flex',
          marginTop: '-1%',
          justifyContent: 'space-between',
          backgroundColor: '#fff',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: '20px' }}>
            {viewMode === 'table' && (
              <div style={{ paddingTop: '24px', display: 'flex' }}>
                <div
                  style={{
                    padding: 8,
                    background: '#f7f7f7',
                    boxShadow: '0px 0px 30px 2px rgba(0, 0, 0, 0.05)',
                    borderRadius: 8,
                    height: 30,
                    width: 30,
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                  onClick={() => navigate('/rov')}
                >
                  <ArrowBackIosNewIcon style={{ fontSize: 18, color: '#1C274C' }} />
                </div>
                <div style={{ color: 'black', fontSize: 20, fontWeight: '500' }}>
                  Fiber Pop List
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
